import React from "react";
import { useAuth } from '../contexts/AuthContext';

const Header = () => {
  const { user, logout } = useAuth();

  // Show DEV badge if user is anonymous (your dev login)
  const DEV_EMAIL = process.env.REACT_APP_DEV_EMAIL || "thomashilltravel@outlook.com";
const isDev = user && user.email && user.email.toLowerCase() === DEV_EMAIL.toLowerCase();

  return (
    <header className="bg-blue-600 text-white p-4 flex items-center justify-between">
      <h1 className="text-3xl font-semibold text-center flex-1">
        Transport Manager Document Portal
      </h1>
      <div className="ml-auto flex items-center gap-3">
        {isDev && (
          <span className="text-xs text-black bg-yellow-200 px-2 py-1 rounded">DEV</span>
        )}
        {user && (
          <>
            <span className="text-sm text-gray-200">
              Signed in as {user.displayName || user.email}
            </span>
            <button onClick={logout} className="px-3 py-2 border rounded bg-white text-blue-600 hover:bg-gray-100">
              Logout
            </button>
          </>
        )}
      </div>
    </header>
  );
};

export default Header;